import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgePipe } from "../shared/pipes/age.pipe";
import { StatusLablesComponent } from "../shared/components/status-lables/status-lables.component";
import { EntityType } from '../shared/share';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-app-agent-table-view',
  standalone: true,
  imports: [CommonModule, AgePipe, StatusLablesComponent,MatTooltipModule],
  templateUrl: './app-agent-table-view.component.html',
  styleUrl: './app-agent-table-view.component.scss'
})
export class AppAgentTableViewComponent {
  @Input() DisplayedColumns: any;
  @Input() data: any;
  @Input() AcessRole: any;
  @Output() confirmStatusUpdateFalse = new EventEmitter<any>();
  @Output() confirmStatusUpdateTrue = new EventEmitter<any>();
  @Output() openinsurerAgentEdit = new EventEmitter<any>();
  ngOnInit() {
    console.log(this.DisplayedColumns)
  }

  enumEntityType = EntityType;


}
